import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntry from "@/pages/home/components/CategoryEntry";
import EditorPicks from "@/pages/home/components/EditorPicks";
import LatestNews from "@/pages/home/components/LatestNews";
import RankingList from "@/pages/home/components/RankingList";
import FeaturedReviews from "@/pages/home/components/FeaturedReviews";
import SiteIntro from "@/pages/home/components/SiteIntro";
import { usePageMeta } from "@/hooks/usePageMeta";
import { movies } from "@/mocks/movies";
import { specials } from "@/mocks/specials";

export default function Home() {
  usePageMeta({
    title: "生活中的玛丽 - 高清电影电视剧资讯与剧情介绍平台",
    description:
      "生活中的玛丽网站为您提供最新电影电视剧资讯、剧情介绍及影评分析，涵盖多种影视类别，帮助您全面了解影视内容。",
    keywords: "生活中的玛丽,电影资讯,电视剧剧情,影视介绍,影视评论,最新影视作品",
  });

  const latest = [...movies].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt)).slice(0, 6);
  const ranking = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 8);
  const picks = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 5);

  return (
    <div className="w-full">
      <HeroCarousel />

      <div className="w-full px-4 md:px-8 py-8 md:py-12 space-y-10 md:space-y-14">
        <CategoryEntry />

        <EditorPicks items={picks} />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-2">
            <LatestNews items={latest} />
          </div>
          <div className="lg:col-span-1">
            <RankingList items={ranking} />
          </div>
        </div>

        <FeaturedReviews specials={specials} />

        <SiteIntro />
      </div>
    </div>
  );
}